import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import styles from "../../../../../../ricercaSegnalazioni/ricercaSegnalazioni.module.css";
import Input from "../../../../../../../components/textbox/Input";
import Utils from "../../../../../../../utils/Utils";
import $ from "jquery";

class EsamiEComplicanze extends Component {

    state = {
        esamiEComplicanze: {
            otite: "",
            polmonite: "",
            insufficienzaRespiratoria: "",
            diarrea: "",
            stomatite: "",
            trombocitopenia: "",
            cheratoCongiuntivite: "",
            laringoTracheBronchite: "",
            convulsioni: "",
            epatiteAumentoTransaminasi: "",
            encefaliteAcuta: "",
            altro: "",
            esito: "",
            dataDecesso: "",
            causaDecesso: "",
            qualiReliquati: "",
            corretto: []

        },
        boxes: [],
        boxesEsito: [],
        boxesEsitoPerInput: []
    }

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this)
        this.disabledCalendar = this.disabledCalendar.bind(this)
        this.createObjectBE = this.createObjectBE.bind(this)
        this.validate = this.validate.bind(this);
        this.divComplicanze = this.divComplicanze.bind(this)
        this.divEsito = this.divEsito.bind(this)
        this.divEsitoPerInput = this.divEsitoPerInput.bind(this)
    }

    componentDidMount() {

        let esamiEComplicanze = this.state.esamiEComplicanze
        if (this.props.segnalazioneCopia && this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.esamiEComplicanze) {
            let esamiEComplicanzeCopia = this.props.segnalazioneCopia.schedaSpeciale.esamiEComplicanze
            for (let key in esamiEComplicanze) {
                if (esamiEComplicanze.hasOwnProperty(key) === esamiEComplicanzeCopia.hasOwnProperty(key)) {
                    esamiEComplicanze[key] = esamiEComplicanzeCopia[key]
                } else {
                    esamiEComplicanze[key] = ""
                }
            }
            this.setState({esamiEComplicanze: esamiEComplicanze})
            this.divComplicanze()
            this.divEsito()
            this.divEsitoPerInput()
            let corretto = this.controlloCorrettezza()
            let oggettoBE = this.createObjectBE()
            this.props.createOggettoBeAndcontrolloCorrettezza("esamiEComplicanze", oggettoBE, corretto)
            this.disabledCalendar()

        } else {
            let corretto = this.controlloCorrettezza()
            let oggettoBE = this.createObjectBE()
            this.divComplicanze()
            this.divEsito()
            this.divEsitoPerInput()
            this.props.createOggettoBeAndcontrolloCorrettezza("esamiEComplicanze", oggettoBE, corretto)
            this.disabledCalendar()
        }


    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.disabledCalendar()
    }

    validate() {

        if (this.state.esamiEComplicanze.dataDecesso && Utils.validateDate(this.state.esamiEComplicanze.dataDecesso, "Messages.DataDecesso", "Messages.DataDecessoOdierna")) {
            return Utils.validateDate(this.state.esamiEComplicanze.dataDecesso, "Messages.DataDecesso", "Messages.DataDecessoOdierna")
        }

        return ""

    }

    obbligatorietaAltro() {
        let complicanze = this.state.esamiEComplicanze
        return complicanze.otite === "2" && complicanze.polmonite === "2" && complicanze.insufficienzaRespiratoria === "2" &&
            complicanze.diarrea === "2" && complicanze.stomatite === "2" && complicanze.trombocitopenia === "2" &&
            complicanze.cheratoCongiuntivite === "2" && complicanze.laringoTracheBronchite === "2" && complicanze.convulsioni === "2" &&
            complicanze.epatiteAumentoTransaminasi === "2" && complicanze.encefaliteAcuta === "2";
    }

    disabledCalendar() {
        if (this.state.esamiEComplicanze.esito !== "2") {
            $(document).ready(function () {
                $("#dataDecesso").datepicker('disable');
            })
        } else {
            $(document).ready(function () {
                $("#dataDecesso").datepicker('enable');
            })
        }
    }

    riceviValore(field, event) {
        let esamiEComplicanze = this.state.esamiEComplicanze
        esamiEComplicanze[field] = event.target.value
        if (esamiEComplicanze.esito !== "2") {
            esamiEComplicanze.dataDecesso = ""
            esamiEComplicanze.causaDecesso = ""
        }
        if (esamiEComplicanze.esito !== "3") {
            esamiEComplicanze.qualiReliquati = ""
        }
        this.setState({esamiEComplicanze: esamiEComplicanze})
        this.divComplicanze()
        this.divEsito()
        this.divEsitoPerInput()
        let corretto = this.controlloCorrettezza()
        let oggettoBE = this.createObjectBE()
        this.props.createOggettoBeAndcontrolloCorrettezza("esamiEComplicanze", oggettoBE, corretto, this.validate())
    }

    createObjectBE() {
        let oggettoBE = JSON.parse(JSON.stringify(this.state.esamiEComplicanze))
        Utils.removeFieldFromObject(oggettoBE, "corretto")
        let res = Utils.removeEmptyValueFromObject(oggettoBE)
        return res
    }

    controlloCorrettezza() {
        let esamiEComplicanze = this.state.esamiEComplicanze
        esamiEComplicanze.corretto = []

        if (!esamiEComplicanze.esito) esamiEComplicanze.corretto[0] = "Campo \"Esito\" mancante";
        if (esamiEComplicanze.esito === "2" && (!esamiEComplicanze.dataDecesso || (esamiEComplicanze.dataDecesso && Utils.isDateInValid(Utils.transformDateForBackend(esamiEComplicanze.dataDecesso), "-")))) esamiEComplicanze.corretto[1] = "Campo \"Se decesso, - Data\" mancante o errato";
        if (esamiEComplicanze.esito === "2" && !esamiEComplicanze.causaDecesso) esamiEComplicanze.corretto[2] = "Campo \"Se decesso, - Causa\" mancante";
        if (esamiEComplicanze.esito === "3" && !esamiEComplicanze.qualiReliquati) esamiEComplicanze.corretto[3] = "Campo \"Se reliquati, - Quali\" mancante";
        if (this.obbligatorietaAltro() && !esamiEComplicanze.altro) esamiEComplicanze.corretto[4] = "Campo \"Altro,specificare\" mancante";

        return esamiEComplicanze.corretto

    }

    divComplicanze() {

        const {t} = this.props

        let rows = [
            {
                label: {text: "SchedaSpecialeMorbillo.otite", tipo: "label", colonna: 1, asterisco: false},
                otiteSi: {
                    id: "otiteSi",
                    text: "SchedaSpecialeMorbillo.si",
                    tipo: "radio",
                    name: "otite",
                    value: "1",
                    colonna: 2
                },
                otiteNo: {
                    id: "otiteNo",
                    text: "SchedaSpecialeMorbillo.no",
                    tipo: "radio",
                    name: "otite",
                    value: "2",
                    colonna: 3
                },
            },
            {
                label: {text: "SchedaSpecialeMorbillo.polmonite", tipo: "label", colonna: 1, asterisco: false},
                polmoniteSi: {
                    id: "polmoniteSi",
                    text: "SchedaSpecialeMorbillo.si",
                    tipo: "radio",
                    name: "polmonite",
                    value: "1",
                    colonna: 2
                },
                polmoniteNo: {
                    id: "polmoniteNo",
                    text: "SchedaSpecialeMorbillo.no",
                    tipo: "radio",
                    name: "polmonite",
                    value: "2",
                    colonna: 3
                },
            },
            {
                label: {
                    text: "SchedaSpecialeMorbillo.insufficienzaRespiratoria",
                    tipo: "label",
                    colonna: 1,
                    asterisco: false
                },
                insufficienzaRespiratoriaSi: {
                    id: "insufficienzaRespiratoriaSi",
                    text: "SchedaSpecialeMorbillo.si",
                    tipo: "radio",
                    name: "insufficienzaRespiratoria",
                    value: "1",
                    colonna: 2
                },
                insufficienzaRespiratoriaNo: {
                    id: "insufficienzaRespiratoriaNo",
                    text: "SchedaSpecialeMorbillo.no",
                    tipo: "radio",
                    name: "insufficienzaRespiratoria",
                    value: "2",
                    colonna: 3
                },
            },
            {
                label: {text: "SchedaSpecialeMorbillo.diarrea", tipo: "label", colonna: 1, asterisco: false},
                diarreaSi: {
                    id: "diarreaSi",
                    text: "SchedaSpecialeMorbillo.si",
                    tipo: "radio",
                    name: "diarrea",
                    value: "1",
                    colonna: 2
                },
                diarreaNo: {
                    id: "diarreaNo",
                    text: "SchedaSpecialeMorbillo.no",
                    tipo: "radio",
                    name: "diarrea",
                    value: "2",
                    colonna: 3
                },
            },
            {
                label: {text: "SchedaSpecialeMorbillo.stomatite", tipo: "label", colonna: 1, asterisco: false},
                stomatiteSi: {
                    id: "stomatiteSi",
                    text: "SchedaSpecialeMorbillo.si",
                    tipo: "radio",
                    name: "stomatite",
                    value: "1",
                    colonna: 2
                },
                stomatiteNo: {
                    id: "stomatiteNo",
                    text: "SchedaSpecialeMorbillo.no",
                    tipo: "radio",
                    name: "stomatite",
                    value: "2",
                    colonna: 3
                },
            },
            {
                label: {text: "SchedaSpecialeMorbillo.trombocitopenia", tipo: "label", colonna: 1, asterisco: false},
                trombocitopeniaSi: {
                    id: "trombocitopeniaSi",
                    text: "SchedaSpecialeMorbillo.si",
                    tipo: "radio",
                    name: "trombocitopenia",
                    value: "1",
                    colonna: 2
                },
                trombocitopeniaNo: {
                    id: "trombocitopeniaNo",
                    text: "SchedaSpecialeMorbillo.no",
                    tipo: "radio",
                    name: "trombocitopenia",
                    value: "2",
                    colonna: 3
                },
            },
            {
                label: {
                    text: "SchedaSpecialeMorbillo.cheratoCongiuntivite",
                    tipo: "label",
                    colonna: 1,
                    asterisco: false
                },
                cheratoCongiuntiviteSi: {
                    id: "cheratoCongiuntiviteSi",
                    text: "SchedaSpecialeMorbillo.si",
                    tipo: "radio",
                    name: "cheratoCongiuntivite",
                    value: "1",
                    colonna: 2
                },
                cheratoCongiuntiviteNo: {
                    id: "cheratoCongiuntiviteNo",
                    text: "SchedaSpecialeMorbillo.no",
                    tipo: "radio",
                    name: "cheratoCongiuntivite",
                    value: "2",
                    colonna: 3
                },
            },
            {
                label: {
                    text: "SchedaSpecialeMorbillo.laringoTracheBronchite",
                    tipo: "label",
                    colonna: 1,
                    asterisco: false
                },
                laringoTracheBronchiteSi: {
                    id: "laringoTracheBronchiteSi",
                    text: "SchedaSpecialeMorbillo.si",
                    tipo: "radio",
                    name: "laringoTracheBronchite",
                    value: "1",
                    colonna: 2
                },
                laringoTracheBronchiteNo: {
                    id: "laringoTracheBronchiteNo",
                    text: "SchedaSpecialeMorbillo.no",
                    tipo: "radio",
                    name: "laringoTracheBronchite",
                    value: "2",
                    colonna: 3
                },
            },
            {
                label: {text: "SchedaSpecialeMorbillo.convulsioni", tipo: "label", colonna: 1, asterisco: false},
                convulsioniSi: {
                    id: "convulsioniSi",
                    text: "SchedaSpecialeMorbillo.si",
                    tipo: "radio",
                    name: "convulsioni",
                    value: "1",
                    colonna: 2
                },
                convulsioniNo: {
                    id: "convulsioniNo",
                    text: "SchedaSpecialeMorbillo.no",
                    tipo: "radio",
                    name: "convulsioni",
                    value: "2",
                    colonna: 3
                },
            },
            {
                label: {
                    text: "SchedaSpecialeMorbillo.epatiteAumentoTransaminasi",
                    tipo: "label",
                    colonna: 1,
                    asterisco: false
                },
                epatiteAumentoTransaminasiSi: {
                    id: "epatiteAumentoTransaminasiSi",
                    text: "SchedaSpecialeMorbillo.si",
                    tipo: "radio",
                    name: "epatiteAumentoTransaminasi",
                    value: "1",
                    colonna: 2
                },
                epatiteAumentoTransaminasiNo: {
                    id: "epatiteAumentoTransaminasiNo",
                    text: "SchedaSpecialeMorbillo.no",
                    tipo: "radio",
                    name: "epatiteAumentoTransaminasi",
                    value: "2",
                    colonna: 3
                },
            },
            {
                label: {text: "SchedaSpecialeMorbillo.encefaliteAcuta", tipo: "label", colonna: 1, asterisco: false},
                encefaliteAcutaSi: {
                    id: "encefaliteAcutaSi",
                    text: "SchedaSpecialeMorbillo.si",
                    tipo: "radio",
                    name: "encefaliteAcuta",
                    value: "1",
                    colonna: 2
                },
                encefaliteAcutaNo: {
                    id: "encefaliteAcutaNo",
                    text: "SchedaSpecialeMorbillo.no",
                    tipo: "radio",
                    name: "encefaliteAcuta",
                    value: "2",
                    colonna: 3
                },
            },

        ]

        let boxes = Utils.createDiv("col-lg-6", "col-lg-2", "col-lg-2", this.riceviValore, this.state.esamiEComplicanze, t, rows)
        return this.setState({boxes: boxes})
    }


    divEsito() {
        const {t} = this.props

        let rows = [
            {
                label: {text: "SchedaSpecialeMorbillo.esito", tipo: "label", colonna: 1, asterisco: true},
                esitoGuarigione: {
                    id: "esitoGuarigione",
                    text: "SchedaSpecialeMorbillo.guarigione",
                    tipo: "radio",
                    name: "esito",
                    value: "1",
                    colonna: 2
                },
                esitoDecesso: {
                    id: "esitoDecesso",
                    text: "SchedaSpecialeMorbillo.decesso",
                    tipo: "radio",
                    name: "esito",
                    value: "2",
                    colonna: 3
                },
                esitoReliquati: {
                    id: "esitoReliquati",
                    text: "SchedaSpecialeMorbillo.reliquati",
                    tipo: "radio",
                    name: "esito",
                    value: "3",
                    colonna: 4
                },
                esitoFollowUp: {
                    id: "esitoFollowUp",
                    text: "SchedaSpecialeMorbillo.followUp",
                    tipo: "radio",
                    name: "esito",
                    value: "4",
                    colonna: 5
                },
            },
        ]
        let boxesEsito = Utils.createDiv("col-lg-2", "col-lg-2", "col-lg-2", this.riceviValore, this.state.esamiEComplicanze, t, rows, "col-lg-2", "col-lg-2")
        return this.setState({boxesEsito: boxesEsito})
    }

    divEsitoPerInput() {
        const {t} = this.props

        let rows = [
            {
                label: {
                    text: "SchedaSpecialeMorbillo.data",
                    tipo: "label",
                    colonna: 1,
                    asterisco: this.state.esamiEComplicanze.esito === "2"
                },
                dataDecesso: {
                    id: "dataDecesso",
                    field: "dataDecesso",
                    tipo: "data",
                    colonna: 2,
                    disabled: this.state.esamiEComplicanze.esito !== "2",
                    style: {opacity: this.state.esamiEComplicanze.esito !== "2" ? "0.5" : ""}
                },
                label2: {
                    text: "SchedaSpecialeMorbillo.quali",
                    tipo: "label",
                    colonna: 4,
                    asterisco: this.state.esamiEComplicanze.esito === "3"
                },
                reliquati: {
                    id: "qualiReliquati",
                    field: "qualiReliquati",
                    text: "SchedaSpecialeMorbillo.reliquati",
                    tipo: "input",
                    disabled: this.state.esamiEComplicanze.esito !== "3",
                    colonna: 5
                },
            },
            {
                label: {
                    text: "SchedaSpecialeMorbillo.causa",
                    tipo: "label",
                    colonna: 1,
                    asterisco: this.state.esamiEComplicanze.esito === "2"
                },
                reliquati: {
                    id: "causaDecesso", field: "causaDecesso", text: "SchedaSpecialeMorbillo.causa", tipo: "input",
                    disabled: this.state.esamiEComplicanze.esito !== "2", colonna: 2
                },
            },
        ]
        let boxesEsitoPerInput = Utils.createDiv("col-lg-1", "col-lg-3", "col-lg-2", this.riceviValore, this.state.esamiEComplicanze, t, rows, "col-lg-1", "col-lg-3")
        return this.setState({boxesEsitoPerInput: boxesEsitoPerInput})
    }


    render() {
        const {t} = this.props

        const complicanze = (
            <div className={"container"}>
                <p style={{color: "black", marginTop: "0.5rem", fontWeight: "bold"}}>
                    {t("SchedaSpecialeMorbillo.complicanze")}
                </p>
                {this.state.boxes}
                <div className={"row"}>
                    <div className={"col-lg-6"}>
                        <p style={{color: "black", marginTop: "0.5rem"}}>
                            {t("SchedaSpecialeMorbillo.altro")}
                            {t("SchedaSpecialeMorbillo.specificare")}
                            {this.obbligatorietaAltro() ? <span className={styles.mandatoryColor}>*</span> : ""}
                        </p>
                    </div>
                    <div className={"col-lg-4"}>
                        <Input
                            id={"altro"}
                            onChange={this.riceviValore}
                            field={"altro"}
                            value={this.state.esamiEComplicanze.altro}
                            placeholder={t("SchedaSpecialeMorbillo.altro")}/>
                    </div>
                </div>

            </div>
        )


        const esito = (
            <div style={{marginTop: "1rem"}} className={"container"}>
                {this.state.boxesEsito}
                <div className={"row"}>
                    <div className={"col-lg-6"}>
                        <p style={{color: "black", marginTop: "0.5rem", fontWeight: "bold"}}>
                            {t("SchedaSpecialeMorbillo.seDecesso")}
                        </p>
                    </div>
                    <div className={"col-lg-6"}>
                        <p style={{color: "black", marginTop: "0.5rem", fontWeight: "bold"}}>
                            {t("SchedaSpecialeMorbillo.seReliquati")}
                        </p>
                    </div>
                </div>
                {this.state.boxesEsitoPerInput}
            </div>
        )


        return (
            <div style={{marginTop: "2rem"}}>
                <h6>{t("SchedaSpecialeMorbillo.esamiEComplicanze")}</h6>
                <hr className={styles.hr}/>
                {complicanze}
                {esito}
            </div>
        );
    }

}

export default withTranslation('common')(EsamiEComplicanze)
